// Mock data for MetaSoul® Music platform

export const mockVibes = [
  {
    id: 'abundance',
    name: 'Abundance Altar',
    description: 'Music to manifest abundance and prosperity in your life',
    color: '#FFD700',
    songCount: 15
  },
  {
    id: 'main-character',
    name: 'Main-Character Energy',
    description: 'Step into your power and embrace your main character era',
    color: '#9D4EDD',
    songCount: 22
  },
  {
    id: 'rave',
    name: 'Rave',
    description: 'High energy spiritual dance music for cosmic celebration',
    color: '#FF6B6B',
    songCount: 18
  },
  {
    id: 'feel-good',
    name: 'Feel-good',
    description: 'Uplifting melodies to raise your vibration and mood',
    color: '#4ECDC4',
    songCount: 25
  },
  {
    id: 'slow-down',
    name: 'Slow it Down',
    description: 'Gentle, meditative music for introspection and calm',
    color: '#95E1D3',
    songCount: 20
  }
];

export const mockSongs = [
  // Abundance Altar
  {
    id: 1,
    title: 'Golden Manifestation',
    artist: 'MetaSoul®',
    album: 'Abundance Flow',
    duration: 245,
    vibes: ['abundance', 'feel-good'],
    genre: 'Spiritual Pop',
    albumArt: 'https://images.unsplash.com/photo-1518837695005-2083093ee35b?w=300&h=300&fit=crop',
    audioUrl: '/songs/golden-manifestation.mp3'
  },
  {
    id: 2,
    title: 'Prosperity Frequency',
    artist: 'MetaSoul®',
    album: 'Wealth Consciousness',
    duration: 198,
    vibes: ['abundance'],
    genre: 'Ambient',
    albumArt: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=300&h=300&fit=crop',
    audioUrl: '/songs/prosperity-frequency.mp3'
  },
  {
    id: 3,
    title: 'Money Magnet Meditation',
    artist: 'MetaSoul®',
    album: 'Abundance Flow',
    duration: 312,
    vibes: ['abundance', 'slow-down'],
    genre: 'Meditation',
    albumArt: 'https://images.unsplash.com/photo-1544531586-fbd96ceaff1a?w=300&h=300&fit=crop',
    audioUrl: '/songs/money-magnet.mp3'
  },

  // Main-Character Energy
  {
    id: 4,
    title: 'I Am Powerful',
    artist: 'MetaSoul®',
    album: 'Empowerment Anthems',
    duration: 267,
    vibes: ['main-character', 'feel-good'],
    genre: 'Empowerment Pop',
    albumArt: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=300&h=300&fit=crop',
    audioUrl: '/songs/i-am-powerful.mp3'
  },
  {
    id: 5,
    title: 'Crown Chakra Confidence',
    artist: 'MetaSoul®',
    album: 'Chakra Activation',
    duration: 223,
    vibes: ['main-character'],
    genre: 'Spiritual R&B',
    albumArt: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=300&h=300&fit=crop',
    audioUrl: '/songs/crown-chakra.mp3'
  },
  {
    id: 6,
    title: 'Divine Feminine Rising',
    artist: 'MetaSoul®',
    album: 'Sacred Feminine',
    duration: 289,
    vibes: ['main-character', 'feel-good'],
    genre: 'Neo-Soul',
    albumArt: 'https://images.unsplash.com/photo-1518837695005-2083093ee35b?w=300&h=300&fit=crop',
    audioUrl: '/songs/divine-feminine.mp3'
  },

  // Rave
  {
    id: 7,
    title: 'Cosmic Dance Floor',
    artist: 'MetaSoul®',
    album: 'Spiritual Rave',
    duration: 334,
    vibes: ['rave', 'feel-good'],
    genre: 'Spiritual EDM',
    albumArt: 'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=300&h=300&fit=crop',
    audioUrl: '/songs/cosmic-dance.mp3'
  },
  {
    id: 8,
    title: 'Frequency Shift',
    artist: 'MetaSoul®',
    album: 'Dimensional Beats',
    duration: 401,
    vibes: ['rave'],
    genre: 'Psychedelic Trance',
    albumArt: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=300&h=300&fit=crop',
    audioUrl: '/songs/frequency-shift.mp3'
  },
  {
    id: 9,
    title: '432Hz Celebration',
    artist: 'MetaSoul®',
    album: 'Sacred Frequencies',
    duration: 298,
    vibes: ['rave', 'feel-good'],
    genre: 'Healing Beats',
    albumArt: 'https://images.unsplash.com/photo-1544531586-fbd96ceaff1a?w=300&h=300&fit=crop',
    audioUrl: '/songs/432hz-celebration.mp3'
  },

  // Feel-good
  {
    id: 10,
    title: 'Soul Sunshine',
    artist: 'MetaSoul®',
    album: 'Joy Frequencies',
    duration: 256,
    vibes: ['feel-good'],
    genre: 'Uplifting Pop',
    albumArt: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=300&h=300&fit=crop',
    audioUrl: '/songs/soul-sunshine.mp3'
  },
  {
    id: 11,
    title: 'Higher Vibration',
    artist: 'MetaSoul®',
    album: 'Frequency Healing',
    duration: 213,
    vibes: ['feel-good', 'abundance'],
    genre: 'Spiritual Reggae',
    albumArt: 'https://images.unsplash.com/photo-1518837695005-2083093ee35b?w=300&h=300&fit=crop',
    audioUrl: '/songs/higher-vibration.mp3'
  },
  {
    id: 12,
    title: 'Gratitude Flow',
    artist: 'MetaSoul®',
    album: 'Thank You Universe',
    duration: 287,
    vibes: ['feel-good', 'slow-down'],
    genre: 'Acoustic Soul',
    albumArt: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=300&h=300&fit=crop',
    audioUrl: '/songs/gratitude-flow.mp3'
  },

  // Slow it Down
  {
    id: 13,
    title: 'Inner Peace Symphony',
    artist: 'MetaSoul®',
    album: 'Meditation Masters',
    duration: 456,
    vibes: ['slow-down'],
    genre: 'Ambient Meditation',
    albumArt: 'https://images.unsplash.com/photo-1544531586-fbd96ceaff1a?w=300&h=300&fit=crop',
    audioUrl: '/songs/inner-peace.mp3'
  },
  {
    id: 14,
    title: 'Moonlight Mantra',
    artist: 'MetaSoul®',
    album: 'Lunar Cycles',
    duration: 389,
    vibes: ['slow-down', 'abundance'],
    genre: 'Chant Fusion',
    albumArt: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=300&h=300&fit=crop',
    audioUrl: '/songs/moonlight-mantra.mp3'
  },
  {
    id: 15,
    title: 'Breathe with the Universe',
    artist: 'MetaSoul®',
    album: 'Cosmic Connection',
    duration: 512,
    vibes: ['slow-down', 'feel-good'],
    genre: 'Nature Sounds',
    albumArt: 'https://images.unsplash.com/photo-1518837695005-2083093ee35b?w=300&h=300&fit=crop',
    audioUrl: '/songs/breathe-universe.mp3'
  }
];

export const mockPlaylists = [
  {
    id: 'daily-mix-1',
    name: 'Daily Mix 1',
    description: 'Abundance and Main Character Energy',
    songIds: [1, 4, 6, 11],
    coverImage: 'https://images.unsplash.com/photo-1518837695005-2083093ee35b?w=300&h=300&fit=crop'
  },
  {
    id: 'discover-weekly',
    name: 'Discover Weekly',
    description: 'New mystical music picked just for you',
    songIds: [2, 5, 8, 10, 14],
    coverImage: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=300&h=300&fit=crop'
  },
  {
    id: 'meditation-flow',
    name: 'Meditation Flow',
    description: 'Perfect for your daily practice',
    songIds: [3, 13, 14, 15],
    coverImage: 'https://images.unsplash.com/photo-1544531586-fbd96ceaff1a?w=300&h=300&fit=crop'
  }
];

export const mockUser = {
  id: 'user123',
  name: 'Spiritual Seeker',
  email: 'seeker@metasoul.com',
  isAdmin: false
};

export const mockAdmin = {
  id: 'admin123', 
  name: 'MetaSoul Admin',
  email: 'admin@metasoul.com',
  isAdmin: true
};